// Curated alias whitelist for linking calculator parameter labels to glossary
// terms whose display name differs from the label the user sees.
//
// WHY THIS EXISTS: getGlossaryLink used to match with bidirectional substring
// (`a.includes(b) || b.includes(a)`), which mislinked — e.g. a parameter simply
// labelled "Tax" would resolve to the specific term "Income Tax", and "rate"
// could latch onto any term containing "rate". We replaced that with EXACT
// normalized matching plus this explicit whitelist, so every non-exact link is
// deliberate and reviewable.
//
//   key   = normalized label/abbreviation (lowercase, [a-z0-9] only)
//   value = the exact glossary term DISPLAY NAME to link to. It must exist in at
//           least one country glossary or scripts/audit-internal-links.ts fails.
//
// Start conservative (empty). Add entries only when a real calculator parameter
// label needs to reach a differently-named term; the audit script guards it.
export const GLOSSARY_ALIASES: Record<string, string> = {};

/** Normalize a term/label for whitelist + exact-match comparison. */
export function normalizeGlossaryKey(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]/g, "");
}
